import { Component } from '@angular/core';

@Component({
  selector: 'app-cards6-examples-41',
  templateUrl: './cards6-examples-41.component.html'
})
export class Cards6Examples41Component {}
